import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import introduceBanner from '@/assets/img/banner/introduce.jpg';
import TabList from '@/components/common/Tab/TabList/TabList';
import IntroduceOwner from '@/components/Introduce/IntroduceOwner/IntroduceOwner';
import History from '@/components/Introduce/History/History';
import ExecutiveList from '@/components/Introduce/ExecutiveList/ExecutiveList';
import Rules from '@/components/Introduce/Rules/Rules';
import { useLocation, useNavigate } from 'react-router-dom';
const Introduce = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const params = location.state?.menu ?? '인사말';
	const tabList = ['인사말', '학회연혁', '임원 및 위원회', '학회회칙'];

	const handleMenuName = (menu: string) => {
		navigate('/introduce', { state: { menu: menu } });
	};

	return (
		<main>
			<SubBanner subTitle="Introduction to the society" title="학회소개" img={introduceBanner} />
			<TabList menuList={tabList} menuKey={params} onListClick={handleMenuName} />
			{params === tabList[0] && <IntroduceOwner />}
			{params === tabList[1] && <History />}
			{params === tabList[2] && <ExecutiveList />}
			{params === tabList[3] && <Rules />}
		</main>
	);
};

export default Introduce;
